// extracted by mini-css-extract-plugin
export default {"animalIcon":"animalIcon__hIPYj"};